import React from 'react';
import DauConsumptionComponent from './DauConsumption';

const DauConsumption: React.FC = () => {
  return <DauConsumptionComponent />;
};

export default DauConsumption;
